﻿import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";

import { hasPermission, toast } from "@/services/Utils";
import api from "@/services/api.service";

import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";
import Fetching from "@/components/Fetching/Fetching";

import classes from "../../maintainers.module.scss";

const EstatesForm = ({ confirmSave, permissions, estates_parents, categories }) => {
	const { addToast } = useToasts();
	const { option, slug } = useParams();
	const navigate = useNavigate();

	const [isFetching, setIsFetching] = useState(true);
	const [name, setName] = useState("");
	const [estateParentID, setEstateParentID] = useState("");
	const [categoriesID, setCategoriesID] = useState("");

	const handleClose = () => {
		emptyFields();

		navigate("/configuracion/campos");
	};

	const validSave = () => {
		if (!name) {
			toast(addToast, "Debe ingresar un nombre para guardar.", "error");
			return false;
		}

		if (!categoriesID) {
			toast(addToast, "Debe seleccionar al menos un tipo de bodega para guardar.", "error");
			return false;
		}

		return true;
	};

	const handleSave = () => {
		const form = {
			slug,
			name,
			estateParentID,
			categoriesID,
		};

		if (validSave()) {
			confirmSave(form, setIsFetching, afterSave);
		}
	};

	const emptyFields = () => {
		setName("");
		setEstateParentID("");
		setCategoriesID("");
	};

	const afterSave = () => {
		handleClose();
		addToast(`Bodega guardada correctamente.`, {
			appearance: "success",
		});
	};

	useEffect(() => {
		setIsFetching(true);
		if (option && slug) {
			api.get("/admin/estates/detail", { slug }).then((response) => {
				const { detail } = response;
				if (detail) {
					setName(detail.name ? detail.name : "");
					setEstateParentID(detail.estate_parent_id ? detail.estate_parent_id : "");
					setCategoriesID(detail.categories_id ? detail.categories_id : "");
				} else {
					addToast(`Ocurrió un problema al cargar la bodega seleccionada.`, {
						appearance: "error",
					});
					handleClose();
				}
				setIsFetching(false);
			});
		} else {
			setIsFetching(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [slug, option]);

	return (
		<Modal show={!!option} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form} size="lg">
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Bodega</h4>
			</Modal.Header>
			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={6} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Nombre</Form.Label>

								<Form.Control value={name} onChange={(e) => setName(e.currentTarget.value)} type="text" />
							</Form.Group>
						</Col>

						<Col md={6} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Campo</Form.Label>

								<CustomInputSelect
									value={estateParentID}
									options={estates_parents ?? []}
									onChange={(value) => setEstateParentID(value ?? "")}
									isClearable
								/>
							</Form.Group>
						</Col>

						<Col>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Tipo de bodega</Form.Label>
								<CustomInputSelect
									value={categoriesID ? categoriesID.split(",").map(Number) : []}
									isMulti
									options={categories ?? []}
									onChange={(values) => setCategoriesID(values && values.length > 0 ? values.toString() : "")}
								/>
							</Form.Group>
						</Col>
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{(slug ? hasPermission("edit", permissions) : hasPermission("create", permissions)) && !isFetching && (
					<Button variant="success" onClick={handleSave}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default EstatesForm;
